import { debounce } from "lodash-es";
import { ref } from "vue-demi";
const windowWidth = ref(window.innerWidth);
const windowHeight = ref(window.innerHeight);
const resizeListener = debounce((entries) => {
  windowWidth.value = window.innerWidth;
  windowHeight.value = window.innerHeight;
}, 600);
window.addEventListener("resize", resizeListener);
export { windowHeight, windowWidth };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/windowSize.js